module.exports = __webpack_public_path__ + "static/media/Army_P.6590c719.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Army_P.svg
// module id = 298
// module chunks = 0